import axios from "axios";
import { API_HEADERS, CREATE_SHIPMENT_BASE_URL } from "../../constants";

export const SuburbOrPostalCode = async (suburbOrPostalCode: any) => {
  try {
    const result = await axios.post(
      `${CREATE_SHIPMENT_BASE_URL}/suburbOrPostCode`,
      {
        ...suburbOrPostalCode,
      },
      {
        headers: API_HEADERS,
      }
    );

    // TODO: Add type once response model is locked in by backend
    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error searching suburbOrPostalCode details", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
